import React, { useMemo, useState, useEffect } from "react";
import { Formik, Form, Field, useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { Button, FormGroup, Label, Row, Col, Input, Container, Card, CardBody } from "reactstrap";
import CustomDatePicker from "common/CustomDatePicker";
import "bootstrap/dist/css/bootstrap.min.css";
import Breadcrumbs from "components/Common/Breadcrumb";
import { fetchCategories, fetchDepartments, fetchEmployeeShiftChange, fetchEmployeeShiftCode, saveEmployeeShift,fetchEmployeeDropdownAutoList, resetShiftChangeList } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import CustomSelect from "components/Common/custom-select";
import TableContainer from "components/Common/TableContainer";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

let shiftdata = [];
const roasterTypeOptions = [{ value: "1", label: "Shift Roaster" }];

const ShiftChange = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const [authDetails, setAuthDetails] = useState(null);
  const dispatch = useDispatch()
  const [value, setValue] = useState('');
  const [items, setItems] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [employeeShifts, setEmployeeShifts] = useState({}); // cache per-employee shifts
  const [activeEmpId, setActiveEmpId] = useState(null);
  const [shiftdata, setShiftData] = useState([]); 
  const [tableData, setTableData] = useState([]);


  useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);

    
  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchDepartments(unitId));
    dispatch(fetchCategories(unitId));
     const formData = new FormData();
    formData.append("emp_id", authUserDetails[0].empid);
    formData.append("unit_id", unitId);
    formData.append("strtxt", "");
    // dispatch(fetchEmployeeShiftCode(formData));
    dispatch(fetchEmployeeDropdownAutoList(unitId));
  }, [dispatch]);

  const {
    categories,
    departments,
    employeeShiftChange,
    dropdownAutoList,
    shifts,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories,
    departments: state.DepartmentMaster?.departments,
    employeeShiftChange: state.AttendanceBiometricReducer?.employeeShiftChange ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
    shifts: state.AttendanceBiometricReducer?.employeeShiftCodes || {},
    loading: state.CategoryMaster?.loading || state.AttendanceBiometricReducer?.loading,
    error: state.AttendanceTimeDeductionsReducer?.error || state.AttendanceBiometricReducer?.error,
    success: state.AttendanceBiometricReducer?.success
  })); 

  // useEffect(() => {
  //   if (Array.isArray(employeeShiftChange) && employeeShiftChange.length > 0) {
  //     const formatted = employeeShiftChange.map(emp => {
  //       const dynamicDates = Object.keys(emp).filter(k => !['emp_id', 'emp_no', 'emp_name', 's_no'].includes(k));
  //       const dateShifts = dynamicDates.reduce((acc, key) => { acc[key] = emp[key]; return acc; }, {});
  //       return { emp_id: emp.emp_id, Code: emp.emp_no, Name: emp.emp_name, ...dateShifts };
  //     });
  //     setTableData(formatted);
  //   }
  // }, [employeeShiftChange]);

  // Validation Schema
  const validationSchema = Yup.object().shape({
    roasterType: Yup.object().required("Roaster Type is required"),
    fromDate: Yup.date().nullable().required("From Date is required"),
    toDate: Yup.date().nullable()
      .required("To Date is required")
      .min(Yup.ref("fromDate"), "To Date cannot be before From Date"),
  });

  const formik = useFormik({
    initialValues: {
      category: [],
      department: [],
      employee: [],
      roasterType: roasterTypeOptions[0], // Default selection
      fromDate: "",
      toDate: "",
    },
    validationSchema,
    onSubmit: (values) => {
// console.log("values>>>>>>>>>",values)
      const formData = new FormData();
      formData.append("cat_id", values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0');
      formData.append("dept_id", values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0');
      formData.append("emp_id", values.employee?.value || "0");
      formData.append("roaster_type", values.roasterType.value === null ? "0" : values.roasterType.value);
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(fetchEmployeeShiftChange(formData)); 
    },
  });

  //console.log("employeeShiftChange>>>>>>>>>>>>>>>>>>",employeeShiftChange);
  let data = [];
  if (Array.isArray(employeeShiftChange) && employeeShiftChange.length > 0) {
    data = employeeShiftChange.map(emp => {
      const dynamicDates = Object.keys(emp).filter(k => !['emp_id', 'emp_no', 'emp_name', 's_no'].includes(k));
      const dateShifts = dynamicDates.reduce((acc, key) => { acc[key] = emp[key]; return acc; }, {});

      return { emp_id: emp.emp_id, Code: emp.emp_no, Name: emp.emp_name, ...dateShifts };
    });
  }

  useEffect(() => {
  if (Array.isArray(employeeShiftChange) && employeeShiftChange.length > 0) {
    const formatted = employeeShiftChange.map((emp) => {
      const dynamicDates = Object.keys(emp).filter(
        (k) => !["emp_id", "emp_no", "emp_name", "s_no"].includes(k)
      );

      const dateShifts = dynamicDates.reduce((acc, key) => {
        const shiftValue = emp[key];

        if (!shiftValue || shiftValue === "-") {
          acc[key] = "-";
        } else if (shiftValue.includes("_")) {
          // 🔹 Split code like "G3_3" → label: "G3", value: "3"
          const [shiftCode, shiftId] = shiftValue.split("_");
          acc[key] = { label: shiftCode, value: shiftId };
        } else {
          acc[key] = { label: shiftValue, value: shiftValue };
        }

        return acc;
      }, {});

      return {
        emp_id: emp.emp_id,
        Code: emp.emp_no,
        Name: emp.emp_name,
        ...dateShifts,
      };
    });

    setTableData(formatted);
  }
}, [employeeShiftChange]);




 const handleOptionChange = async (e, row) => {
  const isChecked = e.target.checked;
  const empId = row.original.emp_id;

  if (isChecked) {
    setSelectedRows((prev) => [...prev, empId]);
    setActiveEmpId(empId);

    // ✅ If already cached, skip API call
    if (employeeShifts[empId] && employeeShifts[empId].length > 0) {
      console.log("✅ Using cached shifts for employee:", empId);
      return;
    }

    try {
      const formData = new FormData();
      formData.append("emp_id", empId || "0");
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("strtxt", "");

      // 🔥 Just dispatch — do NOT expect direct response
      dispatch(fetchEmployeeShiftCode(formData));
    } catch (error) {
      console.error("❌ Error fetching shifts for employee:", empId, error);
      Swal.fire("Error", "Failed to load shift codes for this employee!", "error");
    }
  } else {
    // ✅ Uncheck — remove from selected list
    setSelectedRows((prev) => prev.filter((id) => id !== empId));
    if (activeEmpId === empId) setActiveEmpId(null);
  }
};


useEffect(() => {
  // Only run if we have an active employee and new shift data
  if (activeEmpId && Array.isArray(shifts) && shifts.length > 0) {
    setEmployeeShifts((prev) => ({
      ...prev,
      [activeEmpId]: shifts,
    }));
  }
}, [shifts, activeEmpId]);

const handleChangeDropdown = (rowIndex, dateKey, selectedOption, row) => {
  const empId = row.original.emp_id;

  const newShiftId =
    selectedOption?.value !== undefined ? selectedOption.value : "";
  const newShiftCode =
    selectedOption?.label !== undefined ? selectedOption.label : "";

  console.log("newShiftId >", newShiftId, " newShiftCode >", newShiftCode);

  // 🔹 1. Update the visible UI (keep {label, value} structure)
  setTableData((prev) =>
    prev.map((item) =>
      item.emp_id === empId
        ? {
            ...item,
            [dateKey]: { label: newShiftCode, value: newShiftId },
          }
        : item
    )
  );

  // 🔹 2. Track shift changes
  setShiftData((prev) => {
    const shiftDate = dateKey;

    const existingIndex = prev.findIndex(
      (item) => item.emp_id === empId && item.shift_date === shiftDate
    );

    if (existingIndex !== -1) {
      const updated = [...prev];
      updated[existingIndex].shift_id = newShiftId;
      return updated;
    } else {
      return [
        ...prev,
        {
          emp_id: empId,
          shift_date: shiftDate,
          shift_id: newShiftId,
        },
      ];
    }
  });
};


const columns = useMemo(() => {
  if (!Array.isArray(tableData) || tableData.length === 0) return [];

  return [
    {
      Header: "#",
      id: "select",
      Cell: ({ row }) => {
        const empId = row.original.emp_id;
        const isChecked = selectedRows.includes(empId);
        return (
          <div className="text-center">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => handleOptionChange(e, row)}
            />
          </div>
        );
      },
      className: "text-center",
      disableSortBy: true,
    },
    {
      Header: "S.No",
      Cell: ({ row }) => row.index + 1,
      className: "text-center",
    },
    { Header: "Code", accessor: "Code" },
    { Header: "Name", accessor: "Name" },

    // === Dynamic date columns ===
    ...Object.keys(tableData[0])
      .filter(
        (k) =>
          !["emp_id", "emp_no", "emp_name", "s_no", "Code", "Name"].includes(k)
      )
      .map((dateKey) => ({
        Header: dateKey,
        accessor: dateKey,
        id: dateKey,
        Cell: ({ row }) => {
          const empId = row.original.emp_id;
          const isChecked = selectedRows.includes(empId);
          const shiftArray = employeeShifts[empId] || [];

          const options = shiftArray.map((s) => ({
            value: s.shift_id,
            label: s.shift_code,
          }));

          // Default value: handle object form {label, value} or "-"
          const currentVal = row.original[dateKey];
          const currentValue =
            currentVal && currentVal !== "-"
              ? { label: currentVal.label, value: currentVal.value }
              : null;

          return (
            <div className="text-center">
              <CustomSelect
                options={options}
                value={currentValue}
                onChange={(e) => {
                  if (isChecked)
                    handleChangeDropdown(row.index, dateKey, e, row);
                }}
                isDisabled={!isChecked}
                isLoading={loading}
                placeholder={isChecked ? "Select" : ""}
                styles={{
                  container: (base) => ({
                    ...base,
                    width: "100px",   // 🔥 increase width here
                  })
                }}
              />
            </div>
          );
        },
      })),
  ];
}, [tableData, selectedRows, employeeShifts, loading]);



  // const handlegetShiftCode = (index, value, dateKey) => {
  //   const authUserDetails = useAuthUserDetails();
  //   const unitId = authUserDetails[0].unit_id
  //   const formData = new FormData();
  //   formData.append("emp_id", dateKey.emp_id === null ? "0" : dateKey.emp_id);
  //   formData.append("unit_id", unitId);
  //   formData.append("strtxt", "");

  //   dispatch(fetchEmployeeShiftCode(formData));
  //   setItems(shifts);
  // }
  const [rows, setRows] = useState(employeeShiftChange);
  const handlechangedropdown = (index, dateKey, selectedOption) => {
    const newRows = [...rows];
    employeeShiftChange[index] = { ...employeeShiftChange[index], [dateKey]: selectedOption.label, };
    setRows(newRows);
  }
  
  
  const handleSave = async (e) => {
    e.preventDefault();

    // 🔸 Validate basic selections
    if (!selectedRows.length) {
        Swal.fire({
          icon: "warning",
          title: "No Selection",
          text: "Please select at least one before proceeding.",
        });
      return;
    }

    if (!shiftdata.length) {
      Swal.fire("No Changes", "No shift changes detected to save!", "info");
      return;
    }

    // 🔹 Filter valid shifts (must have shift_id and shift_date)
    const validShifts = shiftdata
      .filter((item) => item.shift_date)
      .map((item) => {
        // Convert date format DD.MM.YY → YYYY-MM-DD
        const [day, month, year] = item.shift_date.split(".");
        const formattedDate = year?.length === 2 ? `20${year}-${month}-${day}` : item.shift_date;

        return {
          emp_id: String(item.emp_id),
          shift_date: formattedDate,
          shift_id: String(item.shift_id),
        };
      });

    if (validShifts.length === 0) {
      Swal.fire("No Valid Data", "No valid shift records found to save!", "info");
      return;
    }

    const lst_employee_shiftchange = { shi: validShifts };

    console.log("✅ Final payload to save:", lst_employee_shiftchange);

    // 🔹 Prepare FormData for API
    const formData = new FormData();
    formData.append("lst_employee_shiftchange", JSON.stringify(lst_employee_shiftchange));
    formData.append("create_by", authDetails?.user_id || "");
    dispatch(saveEmployeeShift(formData));
  };

  // const handleOptionChange = (eve, row1) => {
  //   const isChecked = eve.target.checked;
  //   const updatedData = data.map((row) => {
  //     if (row1.original.emp_id === row.emp_id) {
  //       let emp_id = row.emp_id
  //       if (isChecked) {
  //         if (!shiftdata.some(item => item.emp_id === emp_id)) {
  //           let empData = { emp_id };
  //           for (let i = 4; i < row1.cells.length; i++) {
  //             const header = row1.cells[i].column.Header;
  //             const value = row1.cells[i].value; // or row1.original[header] if needed
  //             empData[header] = value;
  //           }
  //           shiftdata.push(empData);
  //         }
  //       } else {
  //         shiftdata = shiftdata.filter(item => item.emp_id !== emp_id);
  //       }
  //       //console.log("selecteddata>>>>>>", shiftdata)
  //     }
  //   });   
  // }

  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  useEffect(() => {
    if (JSON.stringify(formik.values) === JSON.stringify(formik.initialValues)) {
      handleCancel();
    }
  }, [formik.values]);

  const handleCancel = () => {
    formik.resetForm()
    setSelectedRows([]);
    setEmployeeShifts({});
    setActiveEmpId(null);
    setShiftData([]);
    setTableData([]);
    dispatch(resetShiftChangeList())
  }

  useEffect(() => {
    if (success) {
      handleCancel()
    }
  }, [authDetails, success, dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid>
          <Breadcrumbs title="Shift Management" breadcrumbItem="Shift Change" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <form onSubmit={formik.handleSubmit}>
                    <Row>
                      {/* Category */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>Category</Label>
                          <CustomSelect
                            options={categories.map((cat) => ({ value: cat.empCatgryid.toString(), label: cat.empCategory, }))}
                            name="category"
                            isMulti
                            value={formik.values.category}
                            onChange={(selected) => formik.setFieldValue("category", selected) }
                            isLoading={!categories.length}
                            onBlur={formik.handleBlur}
                            className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                            styles={SelectcustomStyles}
                          />
                          {formik.errors.category && formik.touched.category && (
                            <div className="text-danger">
                              {formik.errors.category}
                            </div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Department */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>Department</Label>
                          <CustomSelect
                            options={departments.map((dep) => ({ value: dep.departmentId.toString(), label: dep.departmentname, }))}
                            name="department"
                            isMulti
                            value={formik.values.department}
                            onChange={(selected) => formik.setFieldValue("department", selected) }
                            isLoading={!departments.length}
                            onBlur={formik.handleBlur}
                            className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                            styles={SelectcustomStyles}
                          />
                          {formik.errors.department &&
                            formik.touched.department && (
                              <div className="text-danger">
                                {formik.errors.department}
                              </div>
                            )}
                        </FormGroup>
                      </Col>

                      {/* Employee Code */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>Employee</Label>
                          <CustomSelect
                            id="employee"
                            name="employee"
                            options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                            value={formik.values.employee || null}  // Store full object
                            onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                            onBlur={formik.handleBlur}
                            className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                          />
                          {/* <Input
                            type="text"
                            name="employeeCode"
                            value={formik.values.employeeCode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          /> */}
                          {formik.errors.employee && formik.touched.employee && (
                            <div className="text-danger">{formik.errors.employee}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Roaster Type */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>
                            Roaster Type <span className="text-danger">*</span>
                          </Label>
                          <CustomSelect
                            options={roasterTypeOptions}
                            name="roasterType"
                            value={formik.values.roasterType}
                            onChange={(selected) =>
                              formik.setFieldValue("roasterType", selected)
                            }
                          />
                          {formik.errors.roasterType &&
                            formik.touched.roasterType && (
                              <div className="text-danger">
                                {formik.errors.roasterType}
                              </div>
                            )}
                        </FormGroup>
                      </Col>

                      {/* From Date */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>
                            From Date <span className="text-danger">*</span>
                          </Label>
                          <CustomDatePicker
                            name="fromDate"
                            value={formik.values.fromDate || null}
                            selected={formik.values.fromDate}
                            onChange={date => formik.setFieldValue("fromDate", date || null)}
                            onBlur={() => formik.setFieldTouched("fromDate", true)}
                          />

                          {formik.errors.fromDate && formik.touched.fromDate && (
                            <div className="text-danger">
                              {formik.errors.fromDate}
                            </div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* To Date */}
                      <Col md={3}>
                        <FormGroup>
                          <Label>
                            To Date <span className="text-danger">*</span>
                          </Label>
                          <CustomDatePicker
                            name="toDate"
                            value={formik.values.toDate || null}
                            selected={formik.values.toDate}
                            onChange={date => formik.setFieldValue("toDate", date || null)}
                            onBlur={() => formik.setFieldTouched("toDate", true)}
                          />

                          {formik.errors.toDate && formik.touched.toDate && (
                            <div className="text-danger">
                              {formik.errors.toDate}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    {/* </Row>

                    <Row> */}
                       <Col className="d-flex align-items-center justify-content-end">
                        {/* Submit Button */}
                        <Button type="submit" className="btn button-search me-2">
                          <i className="fas fa-search me-1" /> Search
                        </Button>
                        <Button type="reset" color="secondary" onClick={handleCancel} className="btn button-cancel me-2"> <i className="fas fa-sync me-1" /> Cancel
                        </Button>
                        {canCreate && (
                          <Button type="button" className="btn button-submit me-2" onClick={handleSave}>
                            <i className="fas fa-paper-plane me-1" /> Save
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  {/* <Table columns={columns} dataSource={data} pagination={false} bordered /> */}
                  <TableContainer columns={columns} data={tableData} isGlobalFilter={true} customPageSize={10} className="custom-header-css" />

                </CardBody>
              </Card>

            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ShiftChange;